'use strict';

angular.module('ringbaPortal')
  .directive('conditionalRequireSelector', function () {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        elem.on('keyup', function () {
          scope.$apply(function () {
            const otherVal = elem
              .closest('form')
              .find(attrs.ngCompareFieldSelector)
              .val();
            const v = (otherVal && (otherVal.length > 0)) ?
              (elem.val() && (elem.val().length > 0)) :
              true;

            ctrl.$setValidity('conditionalrequire', v);
          });
        });
      }
    };
  });
